export const numberWithCommas = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");




  export const numberWithCommasWithoutRounding = (number) => Number(number.toString().match(/^\d+(?:\.\d{0,2})?/))